import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BaseFilterComponent } from '../shared/components/table-filters/base-filter.component';
import { SelectionModel } from '@angular/cdk/collections';
import { merge, of as observableOf } from 'rxjs';
import { startWith, switchMap, map, catchError } from 'rxjs/operators';
import { NotificationsService } from '../shared/services/notifications.service';
import { LookupsService } from '../shared/services/lookups.service';
import { faHistory } from '@fortawesome/pro-light-svg-icons';
import { NotificationHistoryComponent } from './notification-history/notification-history.component';
import {TransferNotificationComponent} from './transfer-notification/transfer-notification.component'
import { ModalService } from '../shared/services/modal.service';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent implements AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);
  @ViewChild(MatSort) sort: MatSort = new MatSort();

  @ViewChildren('filter') filters!: QueryList<BaseFilterComponent>;

  selection = new SelectionModel<any>(true, []);
  resultsLength: number = 0;
  displayedColumns: string[] = [];
  isLoadingResults = true;
  data: any[] = [];
  users: any[] = [];

  faHistory = faHistory;

  constructor(
    private notificationsService: NotificationsService,
    private lookupsService: LookupsService,
     public modalService: ModalService) {
    this.displayedColumns = ['select', 'dateCreated', 'forUser', 'caseReference', 'notificationType', 'notificationText', 'acknowledgedDate', 'readDate', 'dismissedDate', 'actions'];

    this.lookupsService.getAllInternalUsers().subscribe(result => {

      for (const user of result) {
        this.users.push({ name: user.firstName + ' ' + user.lastName, id: user.id })
      }
    });

  }

  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;

  }


  masterToggle() {

    this.isAllSelected() ?
      this.selection.clear() :
      this.data.forEach(row => this.selection.select(row));

  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.data.length;
    return numSelected === numRows;
  }

  ngAfterViewInit(): void {
    this.loadNotifications();
  }


  loadNotifications(){
    const outputs = this.filters.map(button => button.filter);

    this.selection.clear();

    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.selection.clear();
    });

    merge(...outputs).subscribe(() => {
      this.paginator.pageIndex = 0;
      this.selection.clear();
    });

    merge(this.sort.sortChange, this.paginator.page, ...outputs)
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;

                let searchCriteria = {
          page: this.paginator.pageIndex + 1,
          pageSize: this.paginator.pageSize,
          orderBy: this.sort.active,
          orderDirection: this.sort.direction,
          filterNames: this.filters.map(button => button.filterName),
          filterColumns: this.filters.map(button => button.filterColumn),
          filterStrings: this.filters.map(button => button.filterValue)
        };


        return this.notificationsService.getNotifications(searchCriteria);

      }),
      map((data : any) => {

        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.resultsLength = data.recordCount;
        return data.items;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
    ).subscribe(data => this.data = data);
  }

  viewHistory(notificationId: number){

    const modalRef = this.modalService.openWithOptions(NotificationHistoryComponent, {size: 'xl', scrollable: true});
    modalRef.componentInstance.notificationId = notificationId;
  }

  transferNotification(){
   
      const modalRef = this.modalService.openWithOptions(TransferNotificationComponent, {size: 'md'});
      modalRef.componentInstance.selection = this.selection.selected;

      modalRef.result.then(
        (result) => {
          if (result == true)
        this.loadNotifications();
    },
      () => {} // dismissed - do nothing
    );
  }

}
